// This function clears any selection the user might have on anything in the
// document - it's used while the user is dragging the sidebar's size in order
// to prevent the user from highlighting things while they drag.
export default () => {
    if (document.getSelection) {
        let selection = document.getSelection();
        if (selection) {
            // Some older browsers do not have selection.empty()
            // yet and only have selection.removeAllRanges instead.

            if (selection.empty) {
                selection.empty();
            } else if (selection.removeAllRanges) {
                selection.removeAllRanges();
            }
        }
    } else {
        try {
            window.getSelection().removeAllRanges();
            // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}



// WEBPACK FOOTER //
// ./themes/docs/static/js/util/global-deselect.js